import { useState } from 'react'
import { useSport } from '@/hooks/useSport'
import { useApi } from '@/hooks/useApi'
import { fetchRecruits } from '@/lib/api'
import { RecruitCard } from '@/components/RecruitCard'
import { Skeleton } from '@/components/ui/Skeleton'
import { FilterButtonGroup } from '@/components/ui/FilterButtonGroup'
import clsx from 'clsx'

const CLASS_YEAR_OPTIONS = [
  { label: '2025', value: '2025' },
  { label: '2026', value: '2026' },
  { label: '2027', value: '2027' },
  { label: '2028', value: '2028' },
]

export default function RecruitingPage() {
  const { sport, sportLabel } = useSport()
  const [classYear, setClassYear] = useState('2026')
  const [ranked, setRanked] = useState(true)

  const recruits = useApi(
    () => fetchRecruits(sport, { class_year: Number(classYear), ranked: ranked || undefined })
      .then(d => d.recruits || []),
    [sport, classYear, ranked],
  )

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">{sportLabel} Recruiting</h1>
        <p className="text-sm text-slate-400 mt-1">College soccer recruiting rankings and commitments</p>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <FilterButtonGroup options={CLASS_YEAR_OPTIONS} value={classYear} onChange={setClassYear} />
        <button
          onClick={() => setRanked(!ranked)}
          className={clsx(
            'px-3 py-1.5 rounded-lg text-sm font-medium border transition-colors',
            ranked
              ? 'bg-accent/10 border-accent/30 text-accent'
              : 'bg-pitch-800 border-pitch-700 text-slate-400',
          )}
        >
          Ranked Only
        </button>
      </div>

      {recruits.loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} variant="card" className="h-36" />
          ))}
        </div>
      ) : (recruits.data || []).length === 0 ? (
        <div className="card p-12 text-center">
          <p className="text-slate-400">No recruiting data available for this class.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {(recruits.data || []).map((r) => (
            <RecruitCard key={r.id} recruit={r} />
          ))}
        </div>
      )}
    </div>
  )
}
